import { useCompanyCount } from "@/api/services/admin/company";
import { TGetCompanyCountDto } from "@/api/services/admin/company/dtos/get-company-count.dto";

export const useGetCompanyTotalCount = (keyword?: string): TGetCompanyCountDto => {
  const { data: companyCount } = useCompanyCount({ keyword: keyword || undefined });

  return {
    duringContractCount: companyCount?.data?.duringContractCount ?? 0,
    expiredContractCount: companyCount?.data?.expiredContractCount ?? 0,
    trialCount: companyCount?.data?.trialCount ?? 0,
    trialCancelledCount: companyCount?.data?.trialCancelledCount ?? 0,
  };
};
